import { Field, Image, ImageField, Item, Link, LinkField, Text, withDatasourceCheck } from '@sitecore-jss/sitecore-jss-nextjs';

import { ComponentProps } from 'lib/ComponentProps';

import IsSitecoreEditing from 'src/utils/isSitecoreEditing';

import styles from './TextCallToAction.module.css';

type TextCallToActionProps = ComponentProps & {
	fields: {
		Title: Field<string>;
		Description: Field<string>;
		Icon: ImageField;
		Link: LinkField;
		Theme?: Item & {
			fields: {
				Name: {
					value: string;
				};
			};
		};
	};
};

export default withDatasourceCheck()<TextCallToActionProps>(TextCallToAction);

function TextCallToAction(props: TextCallToActionProps): JSX.Element {
	const isEditing = IsSitecoreEditing();

	const colourClass = props.fields?.Theme?.fields?.Name?.value ?? styles.transparent;
	return (
		<article className={`${styles.box} ${colourClass} rounded maxWidth`}>
			<Text tag="h3" field={props.fields?.Title} className={styles.title} />
			<Image className={styles.icon} field={props.fields?.Icon} loading="lazy" height={200} width={300} />
			<Text tag="p" field={props.fields?.Description} className={styles.body} />

			{(isEditing || props.fields?.Link?.value?.href) && <Link field={props.fields?.Link} className={`${styles.link} button white`} />}
		</article>
	);
}
